import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useMasterFamilies() {
  const queryReturnValues = useQuery(
    ["master-product-families"],
    inventoryClient.getMasterProductFamilies,
    {
      staleTime: 1000 * 60,
    }
  );

  return queryReturnValues;
}

export default useMasterFamilies;
